import { render, staticRenderFns } from "./points_record.vue?vue&type=template&id=22b36894&scoped=true"
import script from "./points_record.vue?vue&type=script&lang=js"
export * from "./points_record.vue?vue&type=script&lang=js"
import style0 from "./points_record.vue?vue&type=style&index=0&id=22b36894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b36894",
  null
  
)

export default component.exports